import React from 'react'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { Box } from '@mui/material'
import { Sort } from '@mui/icons-material'
import PropTypes from 'prop-types'

const SortInterface = ({ isFullscreen, sortBy, handleSort }) => {
  return (
    <Box sx={{
      display: isFullscreen ? 'none' : 'flex',
      alignItems: 'center',
      padding: 1
    }}
    >
      <Sort sx={{ marginRight: 1 }} />
      <Select
        value={sortBy}
        onChange={handleSort}
        variant='standard'
        disableUnderline
        inputProps={{
          IconComponent: () => null,
          name: 'update-sort',
          id: 'update-sort'
        }}
      >
        <MenuItem value='ordered'>Ordered</MenuItem>
        <MenuItem value='score-low-high'>Score low to high</MenuItem>
        <MenuItem value='score-high-low'>Score high to low</MenuItem>
        <MenuItem value='progress-low-high'>Progress low to high</MenuItem>
        <MenuItem value='progress-high-low'>Progress high to low</MenuItem>
        <MenuItem value='battery-low-high'>Battery low to high</MenuItem>
      </Select>
    </Box>

  )
}

SortInterface.propTypes = {
  isFullscreen: PropTypes.bool,
  sortBy: PropTypes.any,
  handleSort: PropTypes.func
}

export default SortInterface
